import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { UserMinus, ChartBar, Plus, Calendar, BellMinus, Pill, ChartPie, ClockAlert, ShieldUser } from 'lucide-react';
import { CircularProgress, Snackbar, Alert } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; 
import { IconUserCode } from '@tabler/icons-react';
import Absence from '../../components/tables/Absence.jsx';
import { useRef } from 'react';
import {getAllEmployees} from '../../services/EmployeeService';
import AbsenceForm from '../../components/Forms/AbsenceForm';
import Employee from '../../assets/employee.gif';
import EmployeeCard from '../../components/lists/EmplyeeList.jsx'; 
import PageHeader from '../../components/headers/Header'
import AbsenceDetailsModal from '../../components/DViews/AbsenceDetailsModal';
import AbsenceCalendar from '../../components/calendars/AbsenceCalendar';
import DayDetailsModal from '../../components/DViews/CDayDetails.jsx';
import AbsenceDashboard from '../../components/dash/AbsenceDash';
import JustificationUploadModal from '../../components/DViews/JUModal.jsx';
import AbsenceKPIDashboard from '../../components/KPIDashs/AbsenceKPI.jsx';
import LeaveRequestPage from './leaveRequestPage';
import LeaveRequestForm from '../../components/Forms/LeaveRequestForm';

import { getPendingRequestsOlderThan15Days, getApprovedLeaves, getAllLeaves, getSickLeaves, approveLeave, rejectLeave, getLeavesPerDepartment, getMyLeaves } from '../../services/leavesAPIs';

import {getAllAbsences, getMyAbsences, getAllStagedAbsences, deleteAbsence} from '../../services/absenceAPIs';
import { exportToPdf } from '../../utils/exportToPdf'; 
import { useMediaQuery, Fab, Typography, Box } from '@mui/material';
import FormHeader from '../../components/headers/FormHeader.jsx';

import '../../components/leaves/Leaves.css';

const NotEmployee = localStorage.getItem('userRole')!=='EMPLOYEE';

const AddLateness = () => {
  const [IsEmployee, setIsEmployee]=useState(localStorage.getItem('userRole')==='EMPLOYEE');
  const navigate = useNavigate();
  const [stagedAbsences, setStagedAbsences]= useState([]);

  const dashboardRef = useRef(null);
  const absencesRef = useRef(null);
  const calendarRef = useRef(null);
  const unconfirmedAbsencesRef= useRef(null);
  const addRef = useRef(null);

  console.log(localStorage.getItem('token'));
  const isLargeScreen = useMediaQuery('(min-width: 1600px)');
  
  const location = useLocation(); // Get location

  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedAbsence, setSelectedAbsence]= useState(null);
  const [employees, setEmployees] = useState([]);
  const [sickAbsences, setSickAbsences] = useState([]);
  const [lateAbsences, setLateAbsences] = useState([]);
  const [personalAbsences, setPersonalAbsences] = useState([]);

  const [currentDate] = useState(new Date('2025-06-19T10:26:00+01:00'));
  // const [activeTab, setActiveTab] = useState('overview');
  const [activeTab, setActiveTab] = useState(IsEmployee ? 'add' : 'add');
  const [showEmployeeCard, setShowEmployeeCard] = useState(false);

    const handleEmployeeSelect = (id) => {
    setSelectedEmployeeId(id);
    setShowEmployeeCard(false);
    console.log('Selected employee ID:', id);
  };
  
  // Data fetching
    useEffect(() => {
      const fetchData = async () => {
        try {
          const allEmployees = await getAllEmployees();
          setEmployees(allEmployees);
          console.log("All Employees:", allEmployees);
          console.log("All Employees:", employees);
    
        } catch (error) {
          console.error("Error fetching data:", error);
        }
        };
      fetchData();
    }, []);


  return (
    <div>
       <FormHeader
        title={'Add new lateness record'}
        icon={QueryBuilderIcon}
        onBack={() => {navigate(-1)}}
      />

        {/* {activeTab === 'analytics' && <Analytics />} */}
         <Typography variant="h4" gutterBottom sx={{ mt:2, mb: 1, ml:2.5 , fontWeight: 'bold', color: '#c01557' }}>
          👤 Don't forget to choose the employee
         </Typography>
        
        {isLargeScreen ? (
        <div style={{display: 'flex', gap: '30px'}}>
          <EmployeeCard employees={employees}  onSelectEmployee={handleEmployeeSelect} itemsPerPage={5}/>
          <AbsenceForm Lateness={true} IsEmployee={IsEmployee}  employeeId={selectedEmployeeId} employees={employees} />
        </div>
        ) : (
          <div style={{display: 'flex', gap: '16px'}}>
            <Fab
                onClick={() => setShowEmployeeCard(!showEmployeeCard)}
                sx={{
                  position: 'fixed',
                  bottom: 20,
                  right: 20,
                  zIndex: 1000,
                  backgroundColor: 'var(--card-bg, white)',
                  boxShadow: 3,
                }}
                  >
                  <img
                    src={Employee}
                    alt="Employee"
                    style={{ width: '40px', height: '35px', borderRadius:'5px' }} // Adjust size as needed
                    />   
                </Fab>
            
                {showEmployeeCard && (
                  <Box
                    sx={{
                    position: 'fixed',
                    bottom: 15,
                    right: 100,
                    width: '90%',
                    maxWidth: 500,
                    zIndex: 1000,
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: 'var(--card-bg, white)',
                    p: 2,
                  }}
                  >
                     <EmployeeCard employees={employees}  onSelectEmployee={handleEmployeeSelect} itemsPerPage={2}/>
                  </Box>
                )}

                 <AbsenceForm Lateness={true} IsEmployee={IsEmployee} employeeId={selectedEmployeeId} employees={employees} />
            </div>

        )}     

    </div>
  );
};

export default AddLateness;